import type { FaireProductEntity } from "../../entity_types/product";

export const p_b5bha22mjw: FaireProductEntity = {
  token: "p_b5bha22mjw",
  type: "product",
  name: "1.5” Natural mix Crystal Elephants Healing Energy",
  brandToken: "b_edj9u7j4sq",
  brandName: "KayleeNYC",
  imageUrl:
    "https://cdn.faire.com/fastly/dd38dc3f7ff560221a06736f0d39856059447a0a6400a9346d7c589103272d73.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/301d93cef2c4c898229ca86e5ffa523b4aff38ba16f661cae1c6066e950fa25e.png",
    "https://cdn.faire.com/fastly/522618f71c2d55e249c0e6b6ca83c1a72ec8b158d8ec1dc483206172f69a614f.jpeg",
    "https://cdn.faire.com/fastly/ba5e8cb650027a86bad1a9fb3c752259b471828c01739a620199467dd55d1ae5.jpeg",
    "https://cdn.faire.com/fastly/01aec456f9929d5e1bbb3f7d6d61b5bb2e74d300a31437f0a2cb967cabf8c155.jpeg",
    "https://cdn.faire.com/fastly/061b03bf43a3c259e581d629f8949eac35efe8dd15cb75fd6ca3b3497d17fef3.jpeg",
    "https://cdn.faire.com/fastly/14f43a8314a4ee32be9ee1afc81936623159fcb7e4b4cc9c6933687553f2a742.jpeg",
    "https://cdn.faire.com/fastly/114dec7b4bd3a393947a6906f9bfacae4ef7bf53efa8bc95fa8b0206e36334f5.jpeg",
    "https://cdn.faire.com/fastly/17ddc2a0021020d5706166d86cdc3277694bf5a91bed23e467ce0f71f1d82803.jpeg",
    "https://cdn.faire.com/fastly/28d3403093d2a8e5c37e38fbe6e8eea1f9d73e0af3e0510f09845a9079cbfe3f.jpeg",
    "https://cdn.faire.com/fastly/5bc6ed8d61197d313eff8fd8643e994a0b43660ffaf281339659328c3f57a626.jpeg",
  ],
  priceDollars: 6.03,
  description:
    "1.5”natural crystal Elephants, these Elephants were hand carved and polished. You will receive 1 Rose Quartz, 1 Howlite, 1 Amethyst, 1 Clear Quartz, 1 Red Jasper, 1 Kiwi Jasper, 1 Sodalite, and 1 Aventurine. Minimum order 8 pcs. Condition is New. \n\nFree local pickup in Brooklyn, New York. \n\nStones, crystals, crystal bulk, crystal wholesale, spiritual, meditation, metaphysical wholesale. ",
  tags: [],
  msrpDollars: 12.06,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:01:37.931Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
